let myKey={
publicTestKey: 'test_public_key_4f9e05d6e40c43d2bec3e64ec5abc155',
secretKey: "test_secret_key_f16aba84839545e6b8a979adcfe80132"
}

export default myKey;